import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Input from './Input';
import Select from './Select';
import Button from './Button';

const SearchBar = ({ onSearch }) => {
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState({
    location: '',
    pickupDate: '',
    returnDate: '',
    trailerType: ''
  });

  const trailerTypeOptions = [
    { value: '', label: 'All Types' },
    { value: 'utility', label: 'Utility Trailer' },
    { value: 'enclosed', label: 'Enclosed Trailer' },
    { value: 'flatbed', label: 'Flatbed Trailer' },
    { value: 'car-hauler', label: 'Car Hauler' },
    { value: 'dump', label: 'Dump Trailer' },
    { value: 'equipment', label: 'Equipment Trailer' }
  ];

  const handleInputChange = (field, value) => {
    setSearchData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSearch = (e) => {
    e?.preventDefault();
    
    if (onSearch) {
      onSearch(searchData);
    }
    
    navigate('/search-results', { state: { searchData } });
  };

  const isSearchDisabled = !searchData?.location || !searchData?.pickupDate || !searchData?.returnDate;

  return (
    <div className="w-full max-w-5xl mx-auto">
      <form onSubmit={handleSearch} className="bg-card rounded-lg shadow-elevation-3 p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <div className="lg:col-span-1">
            <Input
              type="text"
              label="Location"
              placeholder="Enter city or zip code"
              value={searchData?.location}
              onChange={(e) => handleInputChange('location', e?.target?.value)}
              required
            />
          </div>

          <div className="lg:col-span-1">
            <Input
              type="date"
              label="Pickup Date"
              value={searchData?.pickupDate}
              onChange={(e) => handleInputChange('pickupDate', e?.target?.value)}
              min={new Date()?.toISOString()?.split('T')?.[0]}
              required
            />
          </div>

          <div className="lg:col-span-1">
            <Input
              type="date"
              label="Return Date"
              value={searchData?.returnDate}
              onChange={(e) => handleInputChange('returnDate', e?.target?.value)}
              min={searchData?.pickupDate || new Date()?.toISOString()?.split('T')?.[0]}
              required
            />
          </div>

          <div className="lg:col-span-1">
            <Select
              label="Trailer Type"
              options={trailerTypeOptions}
              value={searchData?.trailerType}
              onChange={(value) => handleInputChange('trailerType', value)}
              placeholder="Select type"
              id="trailerType"
              name="trailerType"
              description=""
              error=""
            />
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
          <div className="flex items-center space-x-2 text-muted-foreground">
            <Icon name="Info" size={16} strokeWidth={2} />
            <span className="font-caption text-sm">
              Search available trailers in your area
            </span>
          </div>

          <Button
            type="submit"
            variant="default"
            size="lg"
            disabled={isSearchDisabled}
            iconName="Search"
            iconPosition="left"
            className="w-full sm:w-auto"
          >
            Search Trailers
          </Button>
        </div>
      </form>
      <div className="mt-6 flex flex-wrap gap-3 justify-center">
        <button
          type="button"
          onClick={() => handleInputChange('trailerType', 'utility')}
          className="flex items-center space-x-2 px-4 py-2 bg-muted text-foreground rounded-md hover:bg-primary hover:text-primary-foreground transition-smooth"
        >
          <Icon name="Package" size={18} strokeWidth={2} />
          <span className="font-body text-sm">Utility</span>
        </button>
        
        <button
          type="button"
          onClick={() => handleInputChange('trailerType', 'enclosed')}
          className="flex items-center space-x-2 px-4 py-2 bg-muted text-foreground rounded-md hover:bg-primary hover:text-primary-foreground transition-smooth"
        >
          <Icon name="Box" size={18} strokeWidth={2} />
          <span className="font-body text-sm">Enclosed</span>
        </button>
        
        <button
          type="button"
          onClick={() => handleInputChange('trailerType', 'flatbed')}
          className="flex items-center space-x-2 px-4 py-2 bg-muted text-foreground rounded-md hover:bg-primary hover:text-primary-foreground transition-smooth"
        >
          <Icon name="Minus" size={18} strokeWidth={2} />
          <span className="font-body text-sm">Flatbed</span>
        </button>
        
        <button
          type="button"
          onClick={() => handleInputChange('trailerType', 'car-hauler')}
          className="flex items-center space-x-2 px-4 py-2 bg-muted text-foreground rounded-md hover:bg-primary hover:text-primary-foreground transition-smooth"
        >
          <Icon name="Car" size={18} strokeWidth={2} />
          <span className="font-body text-sm">Car Hauler</span>
        </button>
      </div>
    </div>
  );
};

export default SearchBar;